import React from 'react'

function KSCareers() {
  return (
    <div>
        <div>
            <div class="md:container md:mr-16 md:ml-16 pt-2">
                <div class="sm:flex sm:items-center sm:justify-center mx-12 mt-0">
                    <div>
                        <div class="text-center font-semibold py-4 text-3xl">
                            <p class="relative inline-block pb-3">
                            KS Careers 
                                <span class="absolute bottom-0 left-0 w-[50%] h-1 bg-bluetheme"></span>
                            </p>
                        </div>

                    </div> 
                </div>

                <p>
                The KS5 provision offers students a range of courses in three different pathways or areas. 
                Students may choose all of their courses from one area, or combine courses from different ones, 
                depending on their higher education or career goals.<br/><br/>

                Therefore, we aim to provide the following to our young people:<br/><br/>

                <b>1.	Academic<br/><br/>

                KS5 offers a wide range of GCSE, BTEC, A levels, AQAUA and functional skills that provide students 
                with the opportunity to gain qualifications across the full academic spectrum. 

                </b>
                  
                </p>

                <table>
  <tr>
    <th>Languages and Arts</th>
    <th>Science and Maths</th>
    <th>Sports </th>
    <th>Business and Humanities</th>
  </tr>
  <tr>
    <td>
        <ul className='list-disc pl-8'>
            <li>Art</li>
            <li>English Language and literature</li> 
            <li>Media</li>
            <li>Dance </li>
            <li>Performing arts </li>
        </ul>
    </td>
    <td>
    <ul className='list-disc pl-8'>
            <li>Biology</li>
            <li>Animal care</li>
            <li>Land studies</li>
            <li>Maths</li>
         
        </ul>
    </td>
    <td>
    <ul className='list-disc pl-8'>
            <li>Fitness</li> 
            <li>Coaching </li>
            
        </ul>
    </td>

    <td>
    <ul className='list-disc pl-8'>
            <li>Sociology</li>
            <li>Citizenship</li>
            <li>Psychology</li>
            <li>MFLv</li>
            <li>Music </li>
            
        </ul>

    </td>
  </tr>
  
</table><br/><br/>

<p>
    <b>More upon request – depending on subject’s specialist </b><br/>

    We run Non-linear KS5, which mean students take examinations at the end of Y13. This allows for a breadth 
    of learning on each course to be delivered in a linear way, which allows for subjects to teach specifications 
    in more depth. <br/><br/>
We ask students to select a maximum of x 4 subjects in their first year which allows for more flexibility over the year. At the end of Y12, students drop down to x 3 courses; students will be assessed and monitored throughout the year to ensure they are on track. 

</p>

            </div>         
        </div>
    </div>
  )
}

export default KSCareers